export default function PHP_fgetc() {
  return (
    <div>
      <h1>PHP_fgetc</h1>
    </div>
  );
}
